module.exports = __webpack_public_path__ + "img/home-comps.cfb2513a.png";